let spImgList = [
  "https://cdn.shopify.com/s/files/1/0885/3736/6822/8774a6392a94ed1ad10b6d30bf81536f.png",
  "https://cdn.shopify.com/s/files/1/0885/3736/6822/8e71ca67c83ffd70d2d2596aa5b55450.png",
  "https://cdn.shopify.com/s/files/1/0885/3736/6822/1f70dc223a84cc43b2883861cb2e6df8.png",
  "https://cdn.shopify.com/s/files/1/0885/3736/6822/cb1511e7eaa87a96d064c69c7780b107.png",

  "https://cdn.shopify.com/s/files/1/0885/3736/6822/bc52fca902e544465f7c648505753242.png",
  "https://cdn.shopify.com/s/files/1/0885/3736/6822/1befe7853e8c311bc04bf910f95608a1.png",
  "https://cdn.shopify.com/s/files/1/0885/3736/6822/89f8aff7565c31be8038f82e489be905.png",
  "https://cdn.shopify.com/s/files/1/0885/3736/6822/8ef8836ecb6ba5c1e6696b560c847beb.png",
  "https://cdn.shopify.com/s/files/1/0885/3736/6822/799b25dc15bf40975804f407e97c3d36.png",
];
function mainRender() {
$(function () {
  $('#root').css('zoom', 'normal')
  let scale = document.body.clientWidth / 1080
  $('#root').css('zoom', scale)

  window.addEventListener(
    'resize',
    (function () {
      var timer
      return function () {
        if (timer) clearTimeout(timer)
        timer = setTimeout(function () {
          $('#root').css('zoom', 'normal')
          let scale = document.body.clientWidth / 1080
          $('#root').css('zoom', scale)
        }, 100)
      }
    })()
  )
  // 头部固定
  
  $('header').addClass('stiky')
  $(document).scroll(function (e) {
    var beforScrollTop = $(document).scrollTop()
    setTimeout(function () {
      $('header').addClass('stiky')
    }, 50)
  })


  new Swiper("#sp-swiper2", {
  autoplay: true,
  // autoplay: {
  //   disableOnInteraction: false,
  // },
  spaceBetween: 0,
  slidesPerView: "auto",
  centeredSlides: true,
  loop: true,
  pagination: {
    el: ".sp-pagination1",
    clickable: true,
  },
});

  // 数字框初始化
 
  // 动画
  $('#goods-image_header_1').show()
  $('#goods-image_header_2').hide()
  let header_flag = false
  setInterval(() => {
    header_flag = !header_flag
    if (header_flag) {
      $('#goods-image_header_1').hide()
      $('#goods-image_header_2').show()
    } else {
      $('#goods-image_header_1').show()
      $('#goods-image_header_2').hide()
    }
  }, 1000)
  // 生成随机时间
  function generateRandomTime() {
    var hours = Math.floor(Math.random() * 15) + 1
    var minutes = Math.floor(Math.random() * 60)
    var seconds = Math.floor(Math.random() * 60)
    //总共的毫秒数
    var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

    return targetTime
  }
  function TimeDown(value) {
    //倒计时的总秒数
    var totalSeconds = parseInt(value / 1000)
    //取模（余数）
    var modulo = totalSeconds % (60 * 60 * 24)
    //小时数
    var hours = Math.floor(modulo / (60 * 60))
    modulo = modulo % (60 * 60)
    //分钟
    var minutes = Math.floor(modulo / 60)
    //秒
    var seconds = modulo % 60

    hours = hours.toString().length == 1 ? '0' + hours : hours
    minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
    seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

    //输出到页面
    $('.sp_hour').html(hours)
    $('.sp_minute').html(minutes)
    $('.sp_second').html(seconds)
    //延迟一秒执行自己
    if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
    } else {
      setTimeout(function () {
        TimeDown(value - 1000)
      }, 1000)
    }
  }
  TimeDown(generateRandomTime())
})

function lazyLoadImages() {
  // 懒加载
  const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
  const config = {
    rootMargin: '0px 0px 1300px 0px',
    threshold: 0,
  }

  const lazyLoadObserver = new IntersectionObserver(function (
    entries,
    observer
  ) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        // 当图片进入视口时
        const image = entry.target
        const dataSrc = image.getAttribute('data-src')
        image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
        lazyLoadObserver.unobserve(image) // 停止观察该图片
      }
    })
  },
  config)

  images.forEach(function (image) {
    lazyLoadObserver.observe(image) // 开始观察每个图片
  })
}

function preloadImages(imageArray) {
  // 预加载
  // 检查数组数据结构
  if (Array.isArray(imageArray[0])) {
    // 处理二维数组
    imageArray.forEach((subArray) => {
      subArray.forEach((url) => {
        const img = new Image()
        img.src = url
      })
    })
  } else {
    // 处理一维数组
    imageArray.forEach((url) => {
      const img = new Image()
      img.src = url
    })
  }
}

document.addEventListener('DOMContentLoaded', function () {
  lazyLoadImages()
 preloadImages(spImgList);

  // 找到所有跳转套餐的锚点链接
  var links = document.querySelectorAll('a[href^="#shopping"]');
  links.forEach(function (link) {
    link.addEventListener("click", function (event) {
      event.preventDefault(); // 阻止默认的跳转行为
      // var targetElement = document.getElementById('shopping');
      // if (targetElement) {
      //     targetElement.scrollIntoView({ behavior: 'smooth' });
      // } // 方式一
      const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
      const offsetTop = targetElement.offsetTop;
      window.scroll({
        top:
          offsetTop * $("div#root").css("zoom") -
          230 * $("div#root").css("zoom"),
        behavior: "smooth", // 使用 smooth 实现平滑滚动
      }); // 方式二
    });
  });
})

// IOS字体多了间距的处理 给节点添加 sp_system 类名
// 判断当前用户是安卓端还是iOS端
var userAgent = navigator.userAgent || navigator.vendor || window.opera
var isAndroid = /android/i.test(userAgent)
var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

if (isAndroid) {
  console.log('Android')
} else if (isIOS) {
  console.log('iOS')
} else if (isPC) {
  console.log('PC')
} else {
  $('.sp_system').css('letter-spacing', '-4px')
}
let sp_price1 = window.prod[0].price ;
let sp_price2 = window.prod[0].compare_at_price ;

function calcTotal(price, num) {
  let result = (Number(price) * Number(num)/100).toFixed(2);
  result = (result+"").replace(".",',')
  return result;
}



$(".sp-reduce").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) - 1;
  if (num > 0) {
    input.value = num;
  }
  $("#sp_price1").html(calcTotal(sp_price1, input.value));
  $("#sp_price2").html(calcTotal(sp_price2, input.value));
});
$(".sp-add").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) + 1;
  input.value = num;
  $("#sp_price1").html(calcTotal(sp_price1, input.value));
  $("#sp_price2").html(calcTotal(sp_price2, input.value));
});


$('.link-btn').click(function(){
  let num = $(this).siblings('.addGroup').find('input').val()
  num=num?num:1
  let id = $(this).attr('data-id')
   window.location.href = '/cart/' + id + ':' + num
})

}

mainRender()    
